// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3eOhg","error":"Textarea_error__1Mx6o","readonly":"Textarea_readonly__3DQws","disabled":"Textarea_disabled__289cn"};